import { initObservability } from "@webmotors/anunciar.tools";
import { getBuildVersion } from "./build-version";

export { logInfo, logError, setupAxiosObservability, ObservabilityErrorBoundary } from "@webmotors/anunciar.tools";
export { exposeBuildVersion, getBuildVersion } from "./build-version";

const initDatadog = () => {
  initObservability({
    provider: "datadog",
    config: {
      team: "anunciar",
      isDev: import.meta.env.VITE_AUTH_ENV === "development",
      enableRum: true,
      enableLogs: true,
      enableSessionReplayRecording: true,
      shared: {
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN ?? "",
        env: import.meta.env.VITE_DATADOG_ENV ?? "development",
        service: import.meta.env.VITE_DATADOG_SERVICE ?? "wm-consumer-chat-ui",
        site: import.meta.env.VITE_DATADOG_SITE ?? "datadoghq.com",
        version: getBuildVersion(),
      },
      rum: {
        applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID ?? "",
        sessionSampleRate: Number(import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE ?? 20),
        sessionReplaySampleRate: Number(import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE ?? 20),
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
        trackUserInteractions: true,
        errorSampling: {
          enabled: true,
          ttlMs: 60_000,
        },
      },
      logs: {
        sessionSampleRate: 100,
      },
    },
  });
};

export { initDatadog };
